export default {
    individualCardStyle: {
        height: "209px",
        width: "230px",
    },

    singleViewIndividualCardStyle: {
        height: "100px",
        width: "auto",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },

    cardHeader: {
        marginTop: "44px"
    },
    
    singleViewCardHeader: {
        marginTop: 0,
        marginBottom: 0,  
    },
}